import * as React from 'react';

import { Button, Menu, MenuItem } from '@rematter/ui-web';
import { LucideMoreHorizontal, LucideTrash2 } from 'lucide-react';

import { AccountRecord } from '../../_graphql/queryAccounts';

// Component for the action menu cell
export type AccountActionsMenuProps = {
  account: AccountRecord;
  onDelete?: (accountId: string) => void;
};

export const AccountActionsMenu = ({
  account,
  onDelete,
}: AccountActionsMenuProps) => {
  const menuItems = React.useMemo(
    (): MenuItem[] => [
      {
        label: 'Delete Account',
        icon: <LucideTrash2 />,
        onAction: () => onDelete?.(account.id),
      },
    ],
    [account.id, onDelete],
  );

  return (
    <div className="@AccountActionsMenu contents">
      <Menu
        trigger={
          <Button
            size="icon"
            icon={<LucideMoreHorizontal />}
            variant="outline"
          />
        }
        items={menuItems}
      />
    </div>
  );
};
